<template>
<b-row class="pcos disease-pages no-gutters">
  <b-col class="tool-border" cols="12">
    <b-col  v-if="!userData.conditions.infertility" class="reduce-padding" cols="12">
      <wlpHeader :pageTitle="pageTitle" :pageImage="pageImage"></wlpHeader>
    </b-col>
    <b-col  v-if="userData.conditions.infertility" class="reduce-padding" cols="12">
      <wlpHeader :pageTitle="pageTitle2" :pageImage="pageImage"></wlpHeader>
    </b-col>
    <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content  no-gutters">
        <b-row class="body-sec no-gutters">
          <b-col class="reduce-padding top-section" cols="12">
            <b-row class="no-gutters">
              <b-col class="reduce-padding text-section" lg="8" md="8" cols="12">
                <div class="top-text-title bold-text">
                  <span v-if="userData.conditions.infertility">{{$t('common.top-text-title3')}}</span><span v-if="!userData.conditions.infertility">{{$t('common.top-text-title')}}</span>
                </div>
                <div class="top-text bottom-spacing" :class="{'top-text-sp-pcos' : $i18n.locale=='sp'}"  v-if="!userData.conditions.infertility">
           {{$t('infertility.top-text')}}
                </div>
                <div v-if="userData.conditions.infertility" class="top-text top-text-checked" :class="{'top-text-sp-pcos-checked' : $i18n.locale=='sp'}" >{{$t('infertility.top-text2')}}</div>
              </b-col>
              <b-col class="reduce-padding check-section" lg="4" md="4" cols="12">
                <b-row class="check-yes-section pcoss-check no-gutters">
                  <div class="condition-checkboxes pcos-checkbox wlp-checkboxes">
                  <input @change="toggleAdjButtons()" type="checkbox" name="infertilityCondition" v-model="userData.conditions.infertility" id="infertilityCondition" value="infertilityCondition">
                  <label class="" for="infertilityCondition">
                      <div class="condition-label">{{$t('infertility.condition-label-1')}} <br> {{$t('infertility.condition-label-2')}} <br> {{$t('infertility.condition-label-3')}}</div>
                  </label>
                </div>
                </b-row>
              </b-col>
            </b-row>
            <div class="top-hr"></div>
          </b-col>
          
          <b-col class="reduce-padding graph-col" lg="8" md="7" cols="12">
            <div v-if="!userData.conditions.infertility">
              <div class="graph-title graph-title-space graph-title-common-pcos bold-text">
                {{$t('graph.lineGraphTitle')}} {{$t('infertility.lineGraphTitle2')}} 
              </div>
              <div class="graph-sub-title ratio-text graph-title-common">
              <b> {{$t('infertility.lineGraphTitle3')}}</b> ({{$t('common.oddsRatio')}})<sup>a</sup>
              </div>
            </div>
            <div v-if="userData.conditions.infertility">
              <div class="graph-title resumption-text graph-title-common-pcos bold-text">
                {{$t('infertility.bargraphTitle1')}} <br>  {{$t('infertility.bargraphTitle2')}}
              </div>
              <div class="graph-sub-title lower-text graph-title-common">
                <span v-if="userData.adjustButtons.infertility>0">{{userData.adjustButtons.infertility}}% {{$t('graph.lowerWeight')}} </span>
                (%)
              </div>
            </div>
            <div class="graphs-div">
              <div class="bar-graph-div" v-if="userData.conditions.infertility">
                <barGraph :disease="'pcos'" :barValues="userData.calc.pcosRegain" :adjustSelection="userData.adjustButtons.infertility" :displayBars="true" :lblY= lblY :lblEndX="100" :lblStartX="0" :lblSkipX="25"></barGraph>
              </div>
              <div v-if="!userData.conditions.infertility">
            <lineChart :disease="'pcos'" :risk="userData.calc.pcos" :adjustSelection="userData.adjustButtons.infertility" :lblEndX="40" :lblSkipX="1" :lblEndY="5"
            :confInt="this.userData.confInt.pcos"></lineChart>
              </div>
            </div>
        <b-col class="graph-bottom pcos-graph-bottom" cols="12" v-if="!userData.conditions.infertility">
            <b-row class="no-gutters">
              <b-col class="reduce-padding legends order-lg-1 order-2" lg="4" cols="12">
                <b-row class=" no-gutters">
                  <b-col class="reduce-padding risk-bullets" lg="6" md="4" cols="12">
                    <div class="bullet blue"></div>
                    <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.currentRisk')}}</div>
                  </b-col>
                  <b-col class="reduce-padding risk-bullets" lg="6" md="8" cols="12">
                    <div class="bullet green" v-if="userData.adjustButtons.infertility>0" md="6" ></div>
                    <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.infertility>0"  md="6" >{{$t('common.adjustedRisk')}}</div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="reduce-padding x-label-title order-lg-2 order-1" lg="2" cols="12">
                <div class="">{{$t('common.bmi')}}</div>
              </b-col>
              <b-col class="odds-ratio order-lg-3 order-3 safari_only" lg="6" cols="12">
                <b-row class=" no-gutters">
                  <sup class="edpcos-sup"  :class="{'edpcos-sup-sp' : $i18n.locale=='sp'}">a</sup>{{$t('common.or')}}
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          
          <b-col class=" graph-bottom pcos-bar-graph-bottom bar-graph-bottom" v-if="userData.conditions.infertility">
              <b-row class="no-gutters">
                
                  <div class="bottom-section-pcos" :class="{'bottom-section-pcos-sp' : $i18n.locale=='sp'}">
                      <div class ="weight-loss-txt before-loss">
                        <div class="bullet blue"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}">{{$t('common.beforeWeight')}}</div>
                      </div>
                      <div class ="weight-loss-txt after-loss">
                        <div class="bullet green" v-if="userData.adjustButtons.infertility>0 && userData.adjustButtons.infertility<15"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.infertility>0 && userData.adjustButtons.infertility<15">{{$t('common.afterWeight')}}</div>
                      </div>
                  </div>
              
              </b-row>
            </b-col>
          
          </b-col>
          <b-col class="reduce-padding adj-weight-col" md="4" cols="12">
            <b-row class="no-gutters">
              <b-col class="triangle-outer reduce-padding" cols="12">
                <div class="triangle-img"></div>
              </b-col>
              <b-col class="pcos-box reduce-padding">
                <weightAdjustmentBox :disease="'PCOS'" :adjButtons="adjButtonsArray" :condition="userData.conditions.infertility" :adjustSelection="userData.adjustButtons.infertility" @adjustPercUpdate="userData.adjustButtons.infertility=$event"></weightAdjustmentBox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-row>
      <wlpNavigation :navButtons="['info','references','tnc','menu','back','next']" :currentScreen="6"></wlpNavigation>
    </b-col>
  </b-col>
</b-row>
</template>
<script>
  import scrollMixin from "../mixins/scrollMixin";
  import wlpHeader from '../components/wlpHeader.vue';
  import wlpNavigation from '../components/wlpNavigation.vue';
import lineChart from '../components/lineChart.vue';
import barGraph from '../components/barGraph.vue';
import weightAdjustmentBox from '../components/weightAdjustmentBox.vue';
import { mapGetters, mapMutations } from 'vuex';

  export default {
    name: "pcos",
    mixins: [scrollMixin],
    components: {
      'wlpHeader': wlpHeader,
      'wlpNavigation': wlpNavigation,
    'lineChart': lineChart,
    'weightAdjustmentBox': weightAdjustmentBox,
    'barGraph': barGraph,
    },

    data() {
      return {
       pageTitle: this.$t('infertility.pageTitle'),
       pageTitle2: this.$t('infertility.pageTitle2'),
        pageImage: 'pcos-img',
        subtext: '(Polycystic Ovary Syndrome)',
        adjButtonsArray: ['five', 'ten', 'fifteen', 'twenty'],
         lblY: [this.$t('common.bmi'),this.$t('common.bmi')],
       
      };
    },
    
    computed: {
      ...mapGetters('userData', ['userData']),
    },
    
    methods: {
      ...mapMutations('userData', ['saveCalculations','markSectionComplete']),
      adjustedRegain: function(percentLoss) {
        var t = {
          1: 8.3,
          2: 16.7,
          3: 25.0,
          4: 33.3,
          5: 41.7,
          6: 50.0,
          7: 58.3,
          8: 66.7,
          9: 75.0,
          10: 83.3
        };
        return t[percentLoss];
      },
      
      toggleAdjButtons: function() {
        this.adjButtonsArray = this.userData.conditions.infertility?  ['five', 'ten'] : ['five', 'ten', 'fifteen', 'twenty'];
      },
     },
     
    mounted: function() {
      this.scrollToTop();
      this.toggleAdjButtons();
      this.saveCalculations({
        data:{
        current: [0],
        adj5: [Math.round(this.adjustedRegain(5))],
        adj10: [Math.round(this.adjustedRegain(10))],
      }, section: 'pcosRegain'});
      // console.log("pcos: "+JSON.stringify(this.userData.calc.pcosRegain));
      this.markSectionComplete({section:'infertility'});  
    },
  };
</script>


<style lang="scss" scoped>
</style>
